type StatusIconProps = {
  status: string;
};

export default function StatusIcon({ status }: StatusIconProps) {
  const currentStatus = status?.toLowerCase();

  const isApproved = currentStatus === 'approved';
  const isRejected = currentStatus === 'rejected';

  const color = isApproved ? '#22c55e' : isRejected ? '#ef4444' : '#f59e0b';

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {isApproved ? (
        // Check Icon
        <path
          d="M20.707 6.293a1 1 0 0 1 0 1.414l-10 10a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L10 15.586l9.293-9.293a1 1 0 0 1 1.414 0z"
          fill={color}
          fillRule="evenodd"
          clipRule="evenodd"
        />
      ) : (
        // Cross Icon
        <path
          d="M6 6L18 18M18 6L6 18"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
        />
      )}
    </svg>
  );
}
